export const isBaseUrlV2 = (): boolean => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;

    const rootDomainV2 = process.env.GATSBY_ROOT_DOMAIN_V2 || "";
    if (!!rootDomainV2 && hostname.endsWith(rootDomainV2)) {
      return true;
    }
  }
  return false;
};

export const getRootDomain = (): string => {
  if (isBaseUrlV2()) {
    return process.env.GATSBY_ROOT_DOMAIN_V2 || "";
  }
  return process.env.GATSBY_ROOT_DOMAIN || "";
};

export const getSiteUrl = (): string => {
  if (isBaseUrlV2()) {
    return process.env.GATSBY_SITE_URL_V2 || "";
  }
  return process.env.GATSBY_SITE_URL || "";
};

export const getApiBaseUrl = (): string => {
  if (isBaseUrlV2()) {
    return process.env.GATSBY_API_BASE_URL_V2 || "";
  }
  return process.env.GATSBY_API_BASE_URL || "";
};

export const getProfileUrl = (): string => {
  if (isBaseUrlV2()) {
    return process.env.GATSBY_PROFILE_URL_V2 || "";
  }
  return process.env.GATSBY_PROFILE_URL || "";
};
